import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import classes from "./Layout.module.scss";
import { useWindowSize } from "../../hooks/useWindowSize";
import Drawer from "./Drawer/Drawer";
import { useSelector } from "react-redux";
import ToggleDrawerButton from "../UI/ToggleDrawerButton/ToggleDrawerButton";
import noSupportImg from "../../assets/img/responsive-website-no-support.png";
import Icon from "../UI/Icon/Icon";

const POSLayout = ({ children }) => {
  let size = useWindowSize();
  const { isOpen } = useSelector((state) => state.drawer);

  const screenNotSupported = (
    <div className={classes.NoSupportScreen}>
      <ToggleDrawerButton />
      <br />
      <div className={classes.NoSupportScreenContent}>
        <div className={classes.NoSupportScreenContentImg}>
          <img src={noSupportImg} alt="Screen Not Supported" />
          <Icon name="cross-with-circle" />
        </div>
        <h2>View Not Supported</h2>
        <p>
          This screen is not available on mobile. Please use a tablet or desktop
          to access this feature
        </p>
      </div>
    </div>
  );

  return (
    <div className={classes.POSLayout}>
      <Header />
      <div className={classes.Container}>
        {size.width > 850 && <Sidebar />}
        {size.width < 850 && <Drawer show={isOpen} />}
        <main className={classes.Main}>
          {size.width > 374 && children}
          {size.width < 375 && screenNotSupported}
        </main>
      </div>
    </div>
  );
};

export default POSLayout;
